export default "__VITE_ASSET__6441d560__"